// extracted by mini-css-extract-plugin
export default {"popup-container-layout":"DocumentVersionPopup_popup-container-layout__NM4TD","popupContainerLayout":"DocumentVersionPopup_popup-container-layout__NM4TD"};